// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__performance--nGWhJ {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
}
.style__performanceEmbedded--FCKUO {
  gap: 2rem;
  height: auto;
  min-height: 0;
  overflow: visible;
  flex: 1;
}
.style__embeddedGrid--vG0Sx {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  width: 100%;
  min-height: 0;
  align-content: start;
}
.style__embeddedColumn--wBDtH {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
}
.style__embeddedColumn--wBDtH .style__theorySectionFlat--q9qFO {
  margin-left: 0;
  margin-right: 0;
}
@media (max-width: 960px) {
  .style__embeddedGrid--vG0Sx {
    grid-template-columns: 1fr;
  }
}
.style__section--k9sqC {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}
.style__sectionLabel--SU0o9 {
  color: #7d8287;
}
.style__cards--qo0xD {
  display: flex;
  gap: 1rem;
  margin: 0.5rem 0.125rem;
}
.style__smallBox--VL6JU {
  box-shadow: 0 0.25rem 0.5rem -0.125rem rgba(12, 13, 13, 0.1), 0 0 0.25rem -0.125rem rgba(12, 13, 13, 0.06);
  box-shadow: 0 4px 8px -2px rgba(12, 13, 13, 0.1), 0px 0px 4px -2px rgba(12, 13, 13, 0.06);
  border-radius: 8px;
  display: flex;
  padding: 10px 1rem;
  flex-direction: column;
  margin: 0.125rem;
}
.style__theorySectionFlat--q9qFO {
  border-radius: 8px;
  border: 1px solid #e3e4e8;
  display: flex;
  padding: 10px 1rem;
  flex-direction: column;
  margin: 0.125rem;
  background: #fff;
}
.style__label--iRLKa {
  color: #7d8287;
}
.style__topicContainer--BprO6 {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.style__topic--w5YZI {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.style__topicData--sZDM3 {
  display: flex;
  gap: 0.125rem;
}
.style__ratingContainer--rDQQ5 {
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  padding: 10px 0;
}
.style__examList--pfLwM {
  border: 1px solid #e3e4e8;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}
.style__examRow--Ll2Yp {
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #f1f2f4;
}
.style__examRow--Ll2Yp:last-child {
  border-bottom: none;
}
.style__metricsStrip--yYVz_ {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}
.style__metricItem--yg0sB {
  border: 1px solid #e3e4e8;
  border-radius: 8px;
  padding: 1rem 1.5rem;
  background: #fff;
}
.style__metricLabel--EG1Db {
  color: #7d8287;
  display: block;
  margin-bottom: 0.25rem;
}
.style__topicProgressWrap--wa32w {
  border: 1px solid #e3e4e8;
  border-radius: 8px;
  padding: 0.5rem 1rem;
  background: #fff;
}
.style__topicCategoryRow--oxmo8 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0;
  border-bottom: 1px solid #f1f2f4;
}
.style__topicCategoryRow--oxmo8:last-child {
  border-bottom: none;
}
.style__topicCategoryMeta--iQGoF {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.125rem;
}
.style__topicCategoryDuration--PjzI9 {
  color: #7d8287;
}
.style__custom-tooltip--dbpeX {
  background-color: white;
  padding: 5px;
}
.style__noExams--dQ4AL {
  padding: 16px 8px;
  text-align: center;
  color: #62656a;
  font-style: italic;
}
.style__noLicense--kEhwR {
  padding: 16px 8px;
  text-align: center;
  color: #62656a;
  font-style: italic;
  margin-top: 1rem;
}
`, "",{"version":3,"sources":["webpack://./../components/src/StudentsPerformance/style.less","webpack://./../components/src/shadows.less"],"names":[],"mappings":"AAIA;EAEI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AAJJ;AAHA;EAWI,SAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,OAAA;AALJ;AAVA;EAmBI,aAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,oBAAA;AANJ;AAlBA;EA4BI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAPJ;AAzBA;EAmCM,cAAA;EACA,eAAA;AAPN;AAWE;EAAA;IAEI,0BAAA;EATJ;AACF;AAlCA;EA+CI,aAAA;EACA,sBAAA;EACA,aAAA;AAVJ;AAvCA;EAqDI,cAAA;AAXJ;AA1CA;EAyDI,aAAA;EACA,SAAA;EACA,uBAAA;AAZJ;AA/CA;ECSE,0GAAA;EAKA,yFAAA;EDkDE,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;AAZJ;AAxDA;EAwEI,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;AAbJ;AAjEA;EAkFI,cAAA;AAdJ;AApEA;EAsFI,aAAA;EACA,sBAAA;EACA,SAAA;AAfJ;AAzEA;EA4FI,aAAA;EACA,mBAAA;EACA,8BAAA;AAhBJ;AA9EA;EAkGI,aAAA;EACA,aAAA;AAjBJ;AAlFA;EAuGI,aAAA;EACA,SAAA;EACA,8BAAA;EACA,eAAA;AAlBJ;AAxFA;EA8GI,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAnBJ;AA9FA;EAqHI,aAAA;EACA,SAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,gCAAA;AApBJ;AAsBI;EACE,mBAAA;AApBN;AAzGA;EAkII,aAAA;EACA,gDAAA;EACA,SAAA;AAtBJ;AA9GA;EAwII,yBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;AAvBJ;AApHA;EA+II,cAAA;EACA,cAAA;EACA,sBAAA;AAxBJ;AAzHA;EAqJI,yBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;AAzBJ;AA/HA;EA4JI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;AA1BJ;AA4BI;EACE,mBAAA;AA1BN;AAzIA;EAwKI,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,aAAA;AA5BJ;AA/IA;EA+KI,cAAA;AA7BJ;AAlJA;EAmLI,uBAAA;EACA,YAAA;AA9BJ;AAtJA;EAwLI,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AA/BJ;AA5JA;EA+LI,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAhCJ","sourcesContent":["@import '@yaak/components/src/spacing';\n@import '@yaak/components/src/shadows';\n@import '@yaak/components/src/colors';\n\n:local {\n  .performance {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    overflow-y: auto;\n    overflow-x: hidden;\n    width: 100%;\n  }\n\n  .performanceEmbedded {\n    gap: @spacing-200;\n    height: auto;\n    min-height: 0;\n    overflow: visible;\n    flex: 1;\n  }\n\n  .embeddedGrid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: @spacing-200;\n    width: 100%;\n    min-height: 0;\n    align-content: start;\n  }\n\n  .embeddedColumn {\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-200;\n    width: 100%;\n\n    .theorySectionFlat {\n      margin-left: 0;\n      margin-right: 0;\n    }\n  }\n\n  @media (max-width: 960px) {\n    .embeddedGrid {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  .section {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-15;\n  }\n\n  .sectionLabel {\n    color: @color-asphalt-grey-050;\n  }\n\n  .cards {\n    display: flex;\n    gap: @spacing-100;\n    margin: @spacing-50 @spacing-15;\n  }\n\n  .smallBox {\n    .sys-elevation-shadow-level2();\n    border-radius: 8px;\n    display: flex;\n    padding: 10px @spacing-100;\n    flex-direction: column;\n    margin: @spacing-15;\n  }\n\n  .theorySectionFlat {\n    border-radius: 8px;\n    border: 1px solid @color-asphalt-grey-090;\n    display: flex;\n    padding: 10px @spacing-100;\n    flex-direction: column;\n    margin: @spacing-15;\n    background: @color-white;\n  }\n\n  .label {\n    color: @color-asphalt-grey-050;\n  }\n\n  .topicContainer {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-100;\n  }\n\n  .topic {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .topicData {\n    display: flex;\n    gap: @spacing-15;\n  }\n\n  .ratingContainer {\n    display: flex;\n    gap: @spacing-100;\n    justify-content: space-between;\n    padding: 10px 0;\n  }\n\n  .examList {\n    border: 1px solid @color-asphalt-grey-090;\n    border-radius: 8px;\n    overflow: hidden;\n    background: @color-white;\n  }\n\n  .examRow {\n    display: flex;\n    gap: @spacing-100;\n    justify-content: space-between;\n    align-items: center;\n    padding: @spacing-75 @spacing-100;\n    border-bottom: 1px solid @color-asphalt-grey-095;\n\n    &:last-child {\n      border-bottom: none;\n    }\n  }\n\n  .metricsStrip {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: @spacing-100;\n  }\n\n  .metricItem {\n    border: 1px solid @color-asphalt-grey-090;\n    border-radius: 8px;\n    padding: @spacing-100 @spacing-150;\n    background: @color-white;\n  }\n\n  .metricLabel {\n    color: @color-asphalt-grey-050;\n    display: block;\n    margin-bottom: @spacing-25;\n  }\n\n  .topicProgressWrap {\n    border: 1px solid @color-asphalt-grey-090;\n    border-radius: 8px;\n    padding: @spacing-50 @spacing-100;\n    background: @color-white;\n  }\n\n  .topicCategoryRow {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: @spacing-75 0;\n    border-bottom: 1px solid @color-asphalt-grey-095;\n\n    &:last-child {\n      border-bottom: none;\n    }\n  }\n\n  .topicCategoryMeta {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: @spacing-15;\n  }\n\n  .topicCategoryDuration {\n    color: @color-asphalt-grey-050;\n  }\n\n  .custom-tooltip {\n    background-color: white;\n    padding: 5px;\n  }\n\n  .noExams {\n    padding: 16px 8px;\n    text-align: center;\n    color: @color-asphalt-grey-040;\n    font-style: italic;\n  }\n\n  .noLicense {\n    padding: 16px 8px;\n    text-align: center;\n    color: @color-asphalt-grey-040;\n    font-style: italic;\n    margin-top: @spacing-100;\n  }\n}\n","@import 'colors';\n@import 'spacing';\n\n.sys-elevation-shadow-level0() {\n  box-shadow: 0 0 0 0 @color-asphalt-grey-005;\n}\n\n.sys-elevation-shadow-level1() {\n  box-shadow: 0 1px 3px 0 fade(@color-asphalt-grey-005, 10%),\n    0 1px @spacing-15 0 fade(@color-asphalt-grey-005, 6%);\n}\n\n.sys-elevation-shadow-level2() {\n  box-shadow: 0 @spacing-25 @spacing-50 -@spacing-15 fade(@color-asphalt-grey-005, 10%),\n    0 0 @spacing-25 -@spacing-15 fade(@color-asphalt-grey-005, 6%);\n}\n\n.sys-elevation-shadow-level2() {\n  box-shadow: 0 4px 8px -2px fade(@color-asphalt-grey-005, 10%),\n    0px 0px 4px -2px fade(@color-asphalt-grey-005, 6%);\n}\n\n.sys-elevation-shadow-level3() {\n  box-shadow: 0 @spacing-75 @spacing-100 -@spacing-25 fade(@color-asphalt-grey-005, 10%),\n    0 @spacing-25 6px -@spacing-15 fade(@color-asphalt-grey-005, 5%);\n}\n\n.sys-elevation-shadow-level4() {\n  box-shadow: 0 20px @spacing-150 -@spacing-25 fade(@color-asphalt-grey-005, 10%),\n    0 @spacing-50 @spacing-50 -@spacing-25 fade(@color-asphalt-grey-005, 4%);\n}\n\n.sys-elevation-shadow-level5() {\n  box-shadow: 0 @spacing-150 @spacing-300 -@spacing-75 fade(@color-asphalt-grey-005, 15%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"performance": `style__performance--nGWhJ`,
	"performanceEmbedded": `style__performanceEmbedded--FCKUO`,
	"embeddedGrid": `style__embeddedGrid--vG0Sx`,
	"embeddedColumn": `style__embeddedColumn--wBDtH`,
	"theorySectionFlat": `style__theorySectionFlat--q9qFO`,
	"section": `style__section--k9sqC`,
	"sectionLabel": `style__sectionLabel--SU0o9`,
	"cards": `style__cards--qo0xD`,
	"smallBox": `style__smallBox--VL6JU`,
	"label": `style__label--iRLKa`,
	"topicContainer": `style__topicContainer--BprO6`,
	"topic": `style__topic--w5YZI`,
	"topicData": `style__topicData--sZDM3`,
	"ratingContainer": `style__ratingContainer--rDQQ5`,
	"examList": `style__examList--pfLwM`,
	"examRow": `style__examRow--Ll2Yp`,
	"metricsStrip": `style__metricsStrip--yYVz_`,
	"metricItem": `style__metricItem--yg0sB`,
	"metricLabel": `style__metricLabel--EG1Db`,
	"topicProgressWrap": `style__topicProgressWrap--wa32w`,
	"topicCategoryRow": `style__topicCategoryRow--oxmo8`,
	"topicCategoryMeta": `style__topicCategoryMeta--iQGoF`,
	"topicCategoryDuration": `style__topicCategoryDuration--PjzI9`,
	"custom-tooltip": `style__custom-tooltip--dbpeX`,
	"noExams": `style__noExams--dQ4AL`,
	"noLicense": `style__noLicense--kEhwR`
};
export default ___CSS_LOADER_EXPORT___;
